<ng-container *ngIf="!allowTesting || selectedPddjDocument">
    <div class="pddj-upload-page">
        <div class="left-sidenav forms-sidenav">
            <div class="forms-collapse-section">
                <div class="collapse-header">
                    <h4 data-test="pddj-upload-documents-on-jacket-title">
                        {{ jacketDocumentsSection.label }}
                    </h4>
                    <button
                        mat-icon-button
                        aria-label="toggle the display of this section's fields"
                        data-test="pddj-upload-documents-on-jacket-expand-button"
                        (click)="toggleEditFieldDisplay(jacketDocumentsSection)"
                    >
                        <mat-icon>
                            {{ jacketDocumentsSection.isOpen ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                    </button>
                </div>
                <div class="{{ 'documents' + (jacketDocumentsSection.isOpen ? '' : ' collapsed') }}">
                    <mat-list *ngIf="docsOnJacket.length > 0" dense>
                        <ng-container *ngFor="let doc of docsOnJacket">
                            <mat-list-item
                                [matTooltip]="doc.displayName"
                                matTooltipPosition="right"
                                *ngIf="doc.documentStatusId !== 9"
                                (click)="selectDoc(doc)"
                                class="document"
                                [class.selected]="doc.documentId === formDocId"
                                [disabled]="preventDocs(doc)"
                            >
                                <p class="doc-name">{{ doc.displayName }}</p>
                                <div class="green-check">
                                    <mat-icon class="check">check</mat-icon>
                                </div>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                    <div *ngIf="docsOnJacket.length <= 0" class="no-documents-found">
                        <p>No Documents Found.</p>
                    </div>
                </div>
            </div>
            <div class="forms-collapse-section">
                <div class="collapse-header">
                    <h4 data-test="pddj-upload-available-forms-on-jacket">
                        {{ availbleFormsSection.label }}
                    </h4>
                    <button
                        mat-icon-button
                        aria-label="toggle the display of this section's fields"
                        data-test="pddj-upload-available-forms-on-jacket-expand-button"
                        (click)="toggleEditFieldDisplay(availbleFormsSection)"
                    >
                        <mat-icon>
                            {{ availbleFormsSection.isOpen ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                    </button>
                </div>
                <div class="{{ 'documents' + (availbleFormsSection.isOpen ? '' : ' collapsed') }}">
                    <mat-list dense>
                        <mat-list-item
                            [matTooltip]="'Add as New Document'"
                            matTooltipPosition="right"
                            (click)="clearForm()"
                            class="document"
                            [class.selected]="formDocId === undefined"
                        >
                            <p class="doc-name">Add as New Document</p>
                        </mat-list-item>
                        <ng-container *ngFor="let doc of availableForms">
                            <mat-list-item
                                *ngIf="doc.documentStatusId !== 9"
                                (click)="selectDoc(doc)"
                                class="document"
                                [class.selected]="doc.documentId === formDocId"
                                [disabled]="preventDocs(doc)"
                            >
                                <p class="doc-name">{{ doc.displayName }}</p>
                                <span class="document-type">{{ getFormTypeLabel(doc) }}</span>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </div>
            </div>
            <div class="forms-collapse-section">
                <div class="collapse-header">
                    <h4 data-test="pddj-upload-forms-to-add">
                        {{ formsToAddSection.label }}
                    </h4>
                    <button
                        mat-icon-button
                        aria-label="toggle the display of this section's fields"
                        data-test="pddj-upload-forms-to-add-expand-button"
                        (click)="toggleEditFieldDisplay(formsToAddSection)"
                    >
                        <mat-icon>
                            {{ formsToAddSection.isOpen ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                    </button>
                </div>
                <div class="{{ 'documents' + (formsToAddSection.isOpen ? '' : ' collapsed') }}">
                    <mat-list *ngIf="additionalForms.length > 0" dense>
                        <ng-container *ngFor="let doc of additionalForms">
                            <mat-list-item
                                [matTooltip]="doc.displayName"
                                matTooltipPosition="right"
                                *ngIf="doc.documentStatusId !== 9"
                                (click)="selectFormToAdd(doc)"
                                class="document"
                                [class.selected]="doc.documentId === formDocId"
                                [disabled]="preventDocs(doc)"
                            >
                                <p class="doc-name">{{ doc.displayName }}</p>
                                <span class="document-type">{{ getFormTypeLabel(doc) }}</span>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                    <div *ngIf="additionalForms.length <= 0" class="no-documents-found">
                        <p>No Additonal Forms.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="document-form">
            <div class="section-header">
                <div class="title-wrapper">
                    <h1>Apply Document Data</h1>
                    <div class="subtitle-info">
                        <p>
                            Deal #: <span>{{ deal?.dealerDealNumber || 'N/A' }}</span>
                        </p>
                        <p>
                            Jacket ID: <span>{{ deal?.dealId || 'N/A' }}</span>
                        </p>
                    </div>
                </div>
                <div class="title-actions">
                    <button mat-stroked-button color="primary" (click)="changeDeal()">Change Deal</button>
                </div>
            </div>
            <div class="form-wrapper">
                <div class="form-header">
                    <div class="doc-pagination">
                        <p class="pagination-info">
                            Document <span>{{ currentIndex + 1 }}</span> of {{ pddjDocumentQueue.length }}
                            <span class="document-type">{{ documentLabel }}</span>
                        </p>
                    </div>
                    <div class="form-actions">
                        <button mat-button [disabled]="cannotSplitPdf" (click)="splitPdf()">Split PDF</button>
                    </div>
                </div>
                <form class="file-form" [formGroup]="fileInfo">
                    <mat-form-field>
                        <mat-label>File Name</mat-label>
                        <input matInput formControlName="fileName" />
                        <mat-error>File name is requried.</mat-error>
                    </mat-form-field>
                    <div class="checkboxes" [ngClass]="[largeFileUpload ? 'largeDocumentType' : '']">
                        <mat-label>
                            <mat-checkbox formControlName="isDealerOnly"> This document will only be seen by the dealer </mat-checkbox>
                        </mat-label>
                        <mat-label>
                            <mat-checkbox formControlName="createForm" [disabled]="!canSaveToFormLibrary">
                                Add this document to F&I Forms library
                            </mat-checkbox>
                            <br />
                            <mat-hint *ngIf="!canSaveToFormLibrary"> Change the file name to create a new template. </mat-hint>
                        </mat-label>
                    </div>
                </form>
            </div>
            <div *ngIf="currentFile" class="pddj-pdf-viewer-wrapper">
                <pdf-view
                    [template]="title"
                    [dealId]="deal?.dealId"
                    [docId]="activeDocument?.documentId"
                    [document]="currentFile"
                    [fields]="fields"
                    [editFormAction]="editFormAction"
                    [addField]="addField"
                    (outEvent)="eventHandler($event)"
                >
                </pdf-view>
            </div>
        </div>
        <div class="right-sidenav document-edit-sidenav">
            <div class="pddj-tab-group-wrapper" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
                <div>
                    <p *ngIf="tooltipVisible && largeFileUpload" class="largeDocumentType-Tooltip">
                        Given the size of the file, signatures cannot be added for this document. If you want to add signatures to one of the forms in the file,
                        you will need to upload it separately.
                    </p>
                </div>
                <mat-tab-group
                    (selectedTabChange)="editTabChanged($event)"
                    [(selectedIndex)]="activeTabIndex"
                    [ngClass]="[largeFileUpload ? 'largeDocumentType edit-pdf-tabs' : 'edit-pdf-tabs']"
                >
                    <mat-tab label="Edit">
                        <div *ngFor="let section of editFields" class="edit-fields-section">
                            <div class="edit-fields-header">
                                <h3>
                                    <mat-chip-list>
                                        <mat-chip class="{{ section.type ? section.type + '-theme' : '' }}">
                                            <mat-icon>edit</mat-icon>
                                        </mat-chip>
                                    </mat-chip-list>
                                    {{ section.label }}
                                </h3>
                                <button mat-icon-button aria-label="toggle the display of this section's fields" (click)="toggleEditFieldDisplay(section)">
                                    <mat-icon>
                                        {{ section.isOpen ? 'expand_less' : 'expand_more' }}
                                    </mat-icon>
                                </button>
                            </div>
                            <div class="{{ 'actions' + (section.isOpen ? '' : ' collapsed') }}">
                                <button
                                    *ngFor="let field of section.fields"
                                    mat-button
                                    draggable="true"
                                    class="edit-action"
                                    (click)="addFieldEvent(field.fieldType, field.assigneeType)"
                                    (dragstart)="dragStart($event)"
                                    (dragover)="dragOver($event)"
                                    (dragend)="dragEnd($event, field.fieldType, field.assigneeType)"
                                >
                                    <mat-icon>drag_indicator</mat-icon>
                                    {{ field.label }}
                                </button>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Preview">
                        <div class="preview-actions">
                            <button mat-button class="rounded" (click)="setIsViewing(assignees.buyer)">
                                Show Buyer Fields
                                <mat-chip-list>
                                    <mat-chip class="buyer-theme">
                                        <mat-icon>edit</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </button>
                            <button mat-button class="rounded" (click)="setIsViewing(assignees.cobuyer)">
                                Show Co-Buyer Fields
                                <mat-chip-list>
                                    <mat-chip class="cobuyer-theme">
                                        <mat-icon>edit</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </button>
                            <button mat-button class="rounded" (click)="setIsViewing(assignees.dealer)">
                                Show Dealer Fields
                                <mat-chip-list>
                                    <mat-chip class="dealer-theme">
                                        <mat-icon>edit</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </button>
                            <button mat-button class="rounded" (click)="setIsViewing()">
                                Show All Fields
                                <mat-chip-list>
                                    <mat-chip class="buyer-theme">
                                        <mat-icon>edit</mat-icon>
                                    </mat-chip>
                                    <mat-chip class="cobuyer-theme">
                                        <mat-icon>edit</mat-icon>
                                    </mat-chip>
                                    <mat-chip class="dealer-theme">
                                        <mat-icon>edit</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </button>
                            <button mat-button class="rounded" (click)="setIsTesting()">Test All Fields</button>
                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="selectedPddjDocument?.type === 'impact' && formDocId" label="Set Impact Offset">
                        <div>
                            <div *ngIf="isImpactEditingXandY" class="impact-fields-section">
                                <h3>
                                    Starting Impact Location - X: {{ startingDisplayOffSet.x }}, Y:
                                    {{ startingDisplayOffSet.y }}
                                </h3>
                                <h3>New Offset - X: {{ endOffSet.x }}, Y: {{ endOffSet.y }}</h3>
                                <h3>
                                    Current Mouse Location : X: {{ XandYChangeImpact.x }}, Y:
                                    {{ XandYChangeImpact.y }}
                                </h3>
                            </div>
                            <div *ngIf="!isImpactEditingXandY">
                                <h3>No Access</h3>
                                <h3>
                                    Current Mouse Location : X: {{ XandYChangeImpact?.x }}, Y:
                                    {{ XandYChangeImpact?.y }}
                                </h3>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div class="pdf-footer-btns">
                <button *ngIf="activeTab !== 'Set Impact Offset'" mat-stroked-button color="primary" [disabled]="!isImpactEditingXandY" (click)="exitUpload()">
                    Cancel
                </button>
                <button *ngIf="activeTab === 'Set Impact Offset'" mat-stroked-button color="primary" (click)="cancelOffset()">Cancel</button>
                <button *ngIf="activeTab === 'Set Impact Offset'" mat-raised-button color="primary" (click)="savePdfImpactXYChanges($event)">
                    Save Offset
                </button>
                <button
                    *ngIf="activeTab !== 'Set Impact Offset'"
                    mat-raised-button
                    color="primary"
                    [ngClass]="[fileUploadOver100MB ? 'largeDocumentType' : '']"
                    (click)="saveAndContinue()"
                    [disabled]="errorState"
                >
                    Save & Continue
                </button>
            </div>
            <div class="secondary-actions">
                <button mat-button color="primary" (click)="skipDocument()">
                    Skip
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="allowTesting && !selectedPddjDocument">
    <div class="pddj-file-upload-wrapper">
        <h3>Upload PDF File Here.</h3>
        <input multiple type="file" class="file-input" accept=".pdf,.png" (change)="onFilesSelected($event)" #fileUpload />
        <div class="file-upload">
            <button mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">Upload Files</button>
        </div>
        <p>OR</p>
        <div class="json-paste">
            <h3>Paste in the Impact JSON</h3>
            <textarea rows="10" [(ngModel)]="testingJson"></textarea>
            <button type="button" mat-raised-button color="primary" (click)="handleTestJson()">Submit</button>
        </div>
    </div>
</ng-container>

<ddj-spinner *ngIf="isLoading" [phrase]="loadingPhrase"></ddj-spinner>
